module.exports = __webpack_public_path__ + "static/media/home-card-01.f9bafecf.png";